var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-head'),_c('v-sidebar'),_c('div',{staticClass:"main-box",class:{ 'content-collapse': _vm.collapse }},[_c('v-tags'),_c('div',{staticClass:"main-body"},[_c('transition',{attrs:{"name":"move","mode":"out-in"}},[_c('div',{staticClass:"app-main"},[_c('div',{staticClass:"main-view"},[_c('router-view')],1)])])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }